/** License tiers that unlock Telegram and WhatsApp Business navigation. */
export const LICENSE_TYPES_BUSINESS_PLUS_ENTERPRISE = ['BusinessPlus', 'Enterprise'] as const;

/** Normalize license type (e.g. BusinessPlus → BUSINESS_PLUS). */
export const normalizeLicenseType = (licenseType?: string): string => {
  if (!licenseType) return '';
  const trimmed = String(licenseType).trim();
  const withUnderscores = trimmed
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_');
  return withUnderscores.toUpperCase().replace(/_+/g, '_');
};

/** Active instantupdate.ai plan license is Business Plus or Enterprise. */
export const hasInstantUpdateBusinessPlusOrEnterprise = (
  company: { productPlans?: Array<{
    module?: string;
    status?: string;
    licenseType?: string;
    startedAt?: string;
    endsAt?: string;
  }> } | null | undefined,
): boolean => {
  if (!company?.productPlans?.length) return false;
  const now = new Date();
  const allowed = new Set(['BUSINESS_PLUS', 'ENTERPRISE']);
  const plan = company.productPlans.find((p) => {
    if (!p) return false;
    const sameModule = String(p.module || '').toLowerCase() === 'instantupdate.ai';
    const activeStatus = String(p.status || '').toLowerCase() === 'active';
    if (!sameModule || !activeStatus) return false;
    const startedAt = p.startedAt ? new Date(p.startedAt) : null;
    const endsAt = p.endsAt ? new Date(p.endsAt) : null;
    if (startedAt && now < startedAt) return false;
    if (endsAt && now > endsAt) return false;
    return true;
  });
  if (!plan) return false;
  return allowed.has(normalizeLicenseType(plan.licenseType));
};

/** Company has an active, in-date product plan for the given module. */
export const hasActiveProductPlanForModule = (
  company: { productPlans?: Array<{
    module?: string;
    status?: string;
    startedAt?: string;
    endsAt?: string;
  }> } | null | undefined,
  moduleName: string,
): boolean => {
  if (!company) return false;
  const plans = company.productPlans || [];
  const now = new Date();
  return plans.some((plan) => {
    if (!plan) return false;
    const sameModule = String(plan.module).toLowerCase() === moduleName.toLowerCase();
    const activeStatus = String(plan.status || '').toLowerCase() === 'active';
    if (!sameModule || !activeStatus) return false;
    const startedAt = plan.startedAt ? new Date(plan.startedAt) : null;
    const endsAt = plan.endsAt ? new Date(plan.endsAt) : null;
    if (startedAt && now < startedAt) return false;
    if (endsAt && now > endsAt) return false;
    return true;
  });
};
